module.exports = __webpack_public_path__ + "img/73_14.b675275c.png";